import { ComponentProps, useEffect, useRef } from "react"
import { Viewer, type Viewer as ViewerType } from "@toast-ui/react-editor"
import { Banner } from "@/components/ui/banner.tsx"
import { cn } from "@/lib/utils"
import { useCallLineInfo } from "@/modules/patients/hooks/useCallLineInfo"

const CallLineBanner = ({
  variant = "info",
  className,
  testId,
}: {
  variant?: ComponentProps<typeof Banner>["variant"]
  className?: string
  testId?: string
}) => {
  const viewerRef = useRef<ViewerType | null>(null)
  const bannerInfo = useCallLineInfo()

  useEffect(() => {
    if (viewerRef.current) {
      viewerRef.current.getInstance().setMarkdown(bannerInfo)
    }
  }, [bannerInfo])

  return (
    bannerInfo && (
      <Banner
        variant={variant}
        className={cn(className, variant === "info" && "gap-1 rounded-md px-4 py-2.5")}
        data-testid={testId}>
        <div
          className={cn(
            "view-wrapper **:break-normal! **:underline-offset-2",
            variant === "info" && "**:text-on-surface!",
            variant === "warning" && "**:text-on-warning-surface!",
          )}>
          <Viewer
            ref={viewerRef}
            initialValue={bannerInfo}
            linkAttributes={{
              target: "_blank",
              contenteditable: "false",
              rel: "noopener noreferrer",
            }}
          />
        </div>
      </Banner>
    )
  )
}
export { CallLineBanner }
